import { render, staticRenderFns } from "./PainelPropp.vue?vue&type=template&id=00a7e046"
import script from "./PainelPropp.vue?vue&type=script&lang=js"
export * from "./PainelPropp.vue?vue&type=script&lang=js"
import style0 from "./PainelPropp.vue?vue&type=style&index=0&id=00a7e046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports